/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{interpolate as r}from"./interpolate.js";function o(...o){const t=!Array.isArray(o[0]),i=t?0:-1,e=o[0+i],m=o[1+i],n=o[2+i],a=o[3+i],p=r(m,n,{mixer:(x=n[0],(r=>"object"==typeof r&&r.mix)(x)?x.mix:void 0),...a});var x;return t?p(e):p}export{o as transform};
//# sourceMappingURL=transform.js.map
